export class EftLegResult {
  to: string;
  from: string;
  eft: number;

  getTo(): string {
    return this.to;
  }

  setTo(to: string): EftLegResult {
    this.to = to;

    return this;
  }

  getFrom(): string {
    return this.from;
  }

  setFrom(from: string): EftLegResult {
    this.from = from;
    return this;
  }

  getEft(): number {
    return this.eft;
  }

  setEft(eft: number): EftLegResult {
    this.eft = eft;
    return this;
  }
}
